import "core-js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret, faBars, faLanguage, faImage, faAt, faTrash, faFileUpload, faCamera, faSave, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faYoutube, faTelegram, faTwitter, faDiscord } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import i18n from "./i18n";

library.add(
	faUserSecret, faBars, faLanguage, faImage, faAt, faSave,
	faYoutube, faTelegram, faTwitter, faTrash, faFileUpload, faCamera, faDiscord, faGlobe);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: (h) => h(App),
}).$mount("#app");
